import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'clsx'

// Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import { ImageInput } from '@tracklib/kit'
import { Avatar } from 'kit'

// Types
import { Dispatch, State } from 'types'

import styles from './editavatar.css'

type EditAvatarProps = {
  image: string
  className?: string
  sizes?: string
}

const EditAvatar = ({ image, className, sizes }: EditAvatarProps): JSX.Element => {
  const state = useSelector<State, State>(s => s)
  const dispatch = useDispatch() as Dispatch
  const { profileId } = state.auth
  const [newImage, setNewImage] = useState('')
  const [isLoading, setisLoading] = useState(false)

  const handleSave = () => {
    setisLoading(true)
    dispatch(profileActions.avatarSave(newImage, profileId)).then(() => {
      setNewImage('')
      setisLoading(false)
    })
  }

  return (
    <div className={styles.container}>
      <ImageInput
        name="edit_avatar"
        value={newImage}
        onChange={(name: string, img: string) => setNewImage(img)}
        currentImage={<Avatar.Image image={image} className={className} sizes={sizes} />}
        labelClassName={className}
        isLoading={isLoading}
        errorClassName={styles.error}
      />
      <div className={cn(styles.menu, newImage && styles.menuActive)}>
        <button onClick={() => handleSave()}>Save changes</button>
        <button onClick={() => setNewImage('')}>Cancel</button>
      </div>
    </div>
  )
}

export default EditAvatar
